let xhr = require('client/xhr');
let Spinner = require('client/spinner');
let notification = require('client/notification');
let delegate = require('client/delegate');
let FormPayment = require('payments/common/client').FormPayment;
const {localCurrency, shopCurrency} = require('config');
const t = require('engine/i18n/t');
const ParticipantCounter = require('./participantCounter');
const LANG = require('config').lang;

t.i18n.add('signup', require('../../locales/signup/' + LANG + '.yml'));

class OrderForm {

  constructor(options) {
    this.elem = options.elem;

    this.product = 'course';

    if (window.order && window.order.discount) {
      this.discount = {...window.order.discount};
    }

    this.elem.addEventListener('submit', (e) => this.onSubmit(e));

    let participantCounterElem = this.elem.querySelector('[data-elem="participantCounter"]');
    this.participantCounter = new ParticipantCounter({
      elem: participantCounterElem
    });

    participantCounterElem.addEventListener('change-count', event => this.onParticipantChangeCount(event));

    let [buyOptionSelf, buyOptionOthers] = this.elem.buyOption;

    buyOptionSelf.onchange = buyOptionOthers.onchange = e => this.onBuyOptionChange(e);

    this.discountElem = this.elem.querySelector('[data-elem="discount"]');

    this.elem.querySelector('[data-elem="discount-label"]').onclick = e => this.onDiscountLabelClick(e);

    if (window.groupInfo.price < 5000) {
      document.querySelector('.payment-subtitle-invoice-cheap-price').style.display = 'inline';
    }

    this.elem.discountCodeDraft.onkeydown = e => {
      if (e.key == 'Enter') {
        e.preventDefault();
        this.onDiscountEnter(e);
      }
    };

    this.elem.querySelector('[data-elem="discount-apply"]').onclick = e => this.onDiscountApplyClick(e);
    this.elem.querySelector('[data-elem="discount-remove"]').onclick = e => this.removeDiscount();

    this.updateBuyMessage();
  }

  onDiscountLabelClick(event) {
    this.discountElem.classList.toggle('buy-discount_open');
  }

  onDiscountApplyClick(event) {
    let discountCode = this.elem.discountCodeDraft.value;
    if (!discountCode) {
      return;
    }
  }

  onBuyOptionChange(event) {
    if (event.target.value == 1) {
      this.participantCounter.setCount(1);
    }
    this.updateBuyMessage();
  }

  updateBuyMessage() {
    let option1 = this.elem.querySelector('[data-elem="buy-message-1"]');
    let option2 = this.elem.querySelector('[data-elem="buy-message-2"]');

    let [buyOptionSelf, buyOptionOthers] = this.elem.buyOption;
    option1.hidden = !buyOptionSelf.checked;
    option2.hidden = !buyOptionOthers.checked;
  }

  onParticipantChangeCount(event) {
    this.updatePrice();
  }

  updatePrice() {
    let participantsPriceElem = this.elem.querySelector('[data-elem="participantsPrice"]');

    let count = this.participantCounter.getCount();

    let totalPrice = window.groupInfo.price * count;

    let discount = this.discount || window.pageDiscount;

    if (discount) {
      // apply discount
      // if discount < 1 => multiple
      // otherwise => subtract
      totalPrice = (discount.discount < 1) ? Math.round(totalPrice * discount.discount) : (totalPrice - discount.discount);
    }

    // use this.discount OR page discount description (formatted with user email on server)
    let discountDescriptionElem = this.elem.querySelector('[data-elem="discountDescription"]');
    discountDescriptionElem.innerHTML = "";
    if (this.discount) {
      discountDescriptionElem.innerHTML = this.discount.description || "";
    } else if (window.pageDiscount) {
      discountDescriptionElem.innerHTML = window.pageDiscount.description;
    }

    let fullPriceElem = participantsPriceElem.querySelector('.price__full-price-amount price-currency');
    if (fullPriceElem) {
      fullPriceElem.setAttribute('amount', window.groupInfo.price * count);
    }

    participantsPriceElem.querySelector('.price__main-amount price-currency').setAttribute('amount', totalPrice);

    // probably anoter value for non-RUB, but we now have only courses in RUB
    let secondaryAmount = Math.round(totalPrice);

    participantsPriceElem.querySelector('.price__secondary-amount price-currency').setAttribute('amount', secondaryAmount);
  }

  onSubmit(event) {
    event.preventDefault();
    new FormPayment(this, this.elem).submit();
  }

  // return orderData or nothing if validation failed
  getOrderData() {
    let orderData = {};

    if (window.order) {
      orderData.orderNumber = window.order.number;
      // orderData.amount = window.order.amount;
      orderData.email = window.order.email;
    } else {
      orderData.slug = window.groupInfo.slug;
      orderData.orderTemplate = 'course';
    }

    // for editing, we need to submit discount code, even if it's empty
    // (discount may be removed by editor)
    orderData.discountCode = this.discount && this.discount.code;

    // if no promocode, then apply page-level discount code
    if (!orderData.discountCode) {
      let discountCode = window.location.search.match(/[?&]code=([-\w]+)/);
      if (discountCode) {
        orderData.discountCode = discountCode[1];
      }
    }

    orderData.contactName = this.elem.contactName.value;
    orderData.contactPhone = this.elem.contactPhone.value;
    orderData.count = this.participantCounter.getCount();

    let limitOverride = window.location.search.match(/[?&]limitOverride=([-\w]+)/);
    if (limitOverride) {
      orderData.limitOverride = limitOverride[1];
    }

    if (this.elem.contactEmail) {
      if (!this.elem.contactEmail.value) {
        new notification.Error(t('signup.enter_email'));
        this.elem.contactEmail.scrollIntoView();
        setTimeout(function() {
          window.scrollBy(0, -200);
        });
        this.elem.contactEmail.focus();
        return;
      } else {
        orderData.email = this.elem.contactEmail.value;
      }
    }

    if (!orderData.email) {
      orderData.email = window.currentUser.email;
    }

    return orderData;
  }

  onDiscountApplyClick(e) {
    this.loadDiscount();
  }

  onDiscountEnter(e) {
    this.loadDiscount();
  }

  loadDiscount() {
    let discountCode = this.elem.discountCodeDraft.value.trim().toUpperCase();
    if (!discountCode) return;

    let url = `/courses/groups/${window.groupInfo.slug}/discount?code=${discountCode}`;

    let request = this.request({
      url,
      normalStatuses: [200, 404],
    }, this.elem.querySelector('.summary-cost'));

    request.addEventListener('success', (event) => {

      if (request.status == 200) {
        this.discountElem.classList.add('buy-discount_applied');
        this.discount = event.result;
        // replace by (uppercased) discount from server
        this.elem.discountCodeDraft.value = this.discount.code;
        this.elem.discountCodeDraft.disabled = true;
        this.updatePrice();
      } else {
        new notification.Error(event.result.message);
      }

    });
  }

  removeDiscount() {
    this.discountElem.classList.remove('buy-discount_applied');
    this.discount = null;
    this.elem.discountCodeDraft.disabled = false;
    this.updatePrice();
  }

  request(options, elem) {
    let request = xhr(options);

    request.addEventListener('loadstart', function() {
      let onEnd = this.startRequestIndication(elem);
      request.addEventListener('loadend', onEnd);
    }.bind(this));

    return request;
  }

  startRequestIndication(elem) {

    elem.classList.add('modal-overlay_light');

    let spinner = new Spinner({
      elem:      elem.querySelector('button'),
      size:      'small',
      class:     '',
      elemClass: 'button_loading'
    });
    spinner.start();

    return function onEnd() {
      elem.classList.remove('modal-overlay_light');
      if (spinner) spinner.stop();
    };

  }

}


delegate.delegateMixin(OrderForm.prototype);

module.exports = OrderForm;
